import { Col, Row } from "antd";
import DocumentCard from "../../../developer/component/detail/DocumentCard";
import UploadDocument from "../../../developer/component/uploadDoc";
import { Button } from "reactstrap";

const DocumentBusiness = ({
   documents = {},
  developer,
  currentuser,
  setDocuments,
  handleSubmitDocuments,
  isSubmitting
}) => {

  const handleDocChange = (key, file) => {
    setDocuments((prev) => ({
      ...prev,
      [key]: file,
    }));
  };
const hasNewDocs =
  documents?.businessRegistryFileName ||
  documents?.nineaFileName ||
  documents?.statutFileName;
  const hasAllDocs =
    developer?.businessRegistryFileName &&
    developer?.nineaFileName &&
    developer?.statutFileName;

  return (
    <div style={{ padding: "15px" }}>
      <Row className="justify-content-center">
        <Col span={24}>
          <div className="doc mb-3">Documents Business</div>

          <div
            style={{
              display: "flex",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            {developer?.businessRegistryFileName ? (
              <DocumentCard
                title="Registre du commerce"
                file={developer.businessRegistryFileName}
                token={currentuser?.token}
                
              />
            ) : (
              <UploadDocument
                label="Registre du commerce"
                value={documents.businessRegistryFileName}
                onChange={(file) =>
                  handleDocChange("businessRegistryFileName", file)
                }
                 colSize={2}
              />
            )}
            {developer?.nineaFileName ? (
              <DocumentCard
                title="Ninéa"
                file={developer.nineaFileName}
                token={currentuser?.token}
              />
            ) : (
              <UploadDocument
                label="Ninéa"
                value={documents.nineaFileName}
                onChange={(file) =>
                  handleDocChange("nineaFileName", file)
                }
                 colSize={2}
              />
            )}
            {developer?.statutFileName ? (
              <DocumentCard
                title="Statut"
                file={developer.statutFileName}
                token={currentuser?.token}
              />
            ) : (
              <UploadDocument
                label="Statut"
                value={documents.statutFileName}
                onChange={(file) =>
                  handleDocChange("statutFileName", file)
                }
                 colSize={2}
              />
            )}

          </div>
          {!hasAllDocs && (
            <div className="text-start mt-4">
             <Button
              disabled={!hasNewDocs || isSubmitting}
              onClick={handleSubmitDocuments}
              >
                {isSubmitting ? "Envoi..." : "Soumettre les documents"}
              </Button>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default DocumentBusiness;